import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

const NewsletterSectionAsync = dynamic(() => import('../newsletter-section'), {
  ssr: false,
});

/**
 * Newsletter section for the footer
 */
const Newsletter: React.FC = () => {
  return (
    <>
      <div className="bg-primary-main text-other-white -mx-4 px-8 pt-4 pb-6 lg:mx-0 lg:-mt-16 lg:w-1/2 lg:pt-0">
        <h5 className="text-brand-pink text-center text-2xl md:text-3xl lg:-mt-5 lg:text-left lg:text-5xl lg:leading-18">
          <FormattedMessage id="footer:newsletter-main-title" />
        </h5>

        <p data-test="footer:newsletter-title" className="pb-4 leading-tight font-medium">
          <FormattedMessage id="footer:newsletter-title" />
        </p>

        <NewsletterSectionAsync />
      </div>
    </>
  );
};

export default Newsletter;
